import './MediumModal.css'

function MediumModal({ isOpen, title, children, footer, onClose }) {
    if (!isOpen) {
        return null
    }

    return (
        <div
            className="mediumModalOverlay"
            onClick={onClose}
        >
            <div
                className="mediumModalBox"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="mediumModalHeader">
                    <h2>{title}</h2>

                    <button
                        type="button"
                        className="mediumModalClose"
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>

                <div className="mediumModalBody">
                    {children}
                </div>

                {footer && (
                    <div className="mediumModalFooter">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    )
}

export default MediumModal